import { render, staticRenderFns } from "./Sentidos.vue?vue&type=template&id=69885563"
import script from "./Sentidos.vue?vue&type=script&lang=js"
export * from "./Sentidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports